module.exports = __webpack_public_path__ + "static/img/logo-white.2a09b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.png
// module id = wYO/
// module chunks = 1